import { ICadastro } from './icadastro';
import { IDado } from './idado';
export interface IQueueItem {
      ano: number;
      uno: number;
      key: string;
      cadastro: ICadastro | IDado[];
}
